import React from 'react';
import styles from './TextArea.styles';

export default function TextArea({ value, onChangeCb, onBlurCb, placeholder, rows=4, cols, disabled, customStyles={}, tabIndex = '0' }) {
    return <>
        <div style={styles.container}>
            <textarea
                value={value}
                onChange={onChangeCb}
                placeholder={placeholder}
                rows={rows}
                cols={cols}
                disabled={disabled}
                style={{...styles.textAreaStyle, ...customStyles}}
                onBlur={onBlurCb}
                tabIndex={tabIndex}
            />
        </div>
    </>
}